import { AnyAction } from 'redux';

import { DiagnosticsActionResult, ParamOrVar } from '@ems/yoda-ux';
import { IImmutableList, IImmutableMap } from '@ems/yoda-ux/dist/state/redux';
import { StartupDafName } from '../../../../../web/models/constants/getHelpConstants';
import { appContext } from '../../../../../web/models/getHelp/appContext';
import { DafExecutingStatus } from '../../../../../web/models/getHelp/DafExecutingStatus';
import * as types from '../../../../models/actionTypes';
import { IDafState, initialDafState } from '../../../../models/reduxState';

const handleDiagnosticResult = (nodeId: string, isSuccess: boolean, packageName: string, result: string = null) => {
  // Telemetry Result for diagnost result obtained
  // logDiagnosticResult(nodeId, isSuccess, packageName, result);

  const diagnosticResults: ParamOrVar[] = [];
  const userChoices: string[] = [];
  if (isSuccess && result !== null) {
    // eslint-disable-next-line @typescript-eslint/ban-types
    const resultObject: {} = JSON.parse(result);
    for (const [name, value] of Object.entries(resultObject)) {
      if (name === 'UserChoices') {
        Array.prototype.push.apply(userChoices, JSON.parse(String(value)) as string[]);
      } else {
        diagnosticResults.push({ name: name, value: String(value) });
      }
    }
  } else {
    if (result === null) {
      result = '';
      isSuccess = false;
    }
    const element: ParamOrVar = { name: 'Error', value: result };
    diagnosticResults.push(element);
  }

  const diagnosticActionResult: DiagnosticsActionResult = {
    IsSuccess: isSuccess,
    Results: (diagnosticResults as unknown) as IImmutableList<IImmutableMap<ParamOrVar>>,
    DynamicChoices: (userChoices as unknown) as IImmutableList<string>,
  };

  if (window.yoda?.IntentGraph?.Events?.onDafDiagnosticsActionCompleted) {
    // Signal the renderer back that action is completed
    window.yoda.IntentGraph.Events.onDafDiagnosticsActionCompleted(nodeId, diagnosticActionResult);
  }
};

export const DafReducer = (state: IDafState = initialDafState, action: AnyAction): IDafState => {
  switch (action.type) {
    case types.DIAGNOSTIC_RUN_START:
      return { ...state, ...action.payload };
    case types.DIAGNOSTIC_RUN_COMPLETE:
      const successResult = action.payload as string;
      try {
        const resultRecord: Record<string, string> = JSON.parse(successResult);
        if (resultRecord?.TroubleshooterName !== StartupDafName) {
          handleDiagnosticResult(state.nodeId, true, state.packageName, successResult);
          return { ...state, nodeId: '', packageName: '' };
        } else if (state.startupDiagStatus === DafExecutingStatus.Executing) {
          return { ...state, startupDiagStatus: DafExecutingStatus.Succeed, startupDiagResult: resultRecord };
        }
        break;
      } catch (error) {
        // Fall through to the types.DIAGNOSTIC_RUN_ERROR case;
      }
    // eslint-disable-next-line no-fallthrough
    case types.DIAGNOSTIC_RUN_ERROR:
      const errorResult = action.payload as string;
      if (!!state.nodeId && !!state.packageName && !errorResult.includes(appContext.startupCheckDafSessionId)) {
        handleDiagnosticResult(state.nodeId, false, state.packageName, errorResult);
        return { ...state, nodeId: '', packageName: '' };
      } else if (state.startupDiagStatus === DafExecutingStatus.Executing) {
        return { ...state, startupDiagStatus: DafExecutingStatus.Failed };
      }
      break;
    case types.SET_STARTUP_DIAG_STATUS:
      return { ...state, startupDiagStatus: action.payload as DafExecutingStatus };
  }
  return state;
};
